/* istanbul ignore file */
import { Observable, of } from 'rxjs';

export class KHMapMarker {
    id: string;
    marker: any;

    private constructor(siteId: string, marker: any) {
        this.id = siteId;
        this.marker = marker;
    }

    static create$(siteId: string, options?: google.maps.MarkerOptions): Observable<KHMapMarker> {
        const marker = new google.maps.Marker(options);
        return of(new KHMapMarker(siteId, marker));
    }

    setMap(map: google.maps.Map | null) {
        this.marker.setMap(map);
    }

    getMap() {
        return this.marker.getMap();
    }

    setTitle(title: string) {
        this.marker.setTitle(title);
    }

    getPosition() {
        return this.marker.getPosition();
    }
}
